<template>
  <div class="event-card" @click="$emit('view-detail', event.id)">
    <img :src="event.cover" :alt="event.title" class="card-cover" />
    <div class="card-body">
      <h3>{{ event.title }}</h3>
      <p class="card-subtitle">{{ event.subtitle }}</p>
      <p class="card-meta">📅 {{ event.time }}</p>
      <p class="card-meta">📍 {{ event.place }}</p>
      <p class="card-desc">{{ event.desc }}</p>
      <div class="card-action">
        <span class="view-detail">查看详情 →</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventCard',
  props: {
    event: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.event-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 91, 175, 0.1);
  cursor: pointer;
  transition: all 0.3s;
  border-top: 3px solid #005BAF;
}

.event-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 91, 175, 0.2);
}

.card-cover {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

.card-body {
  padding: 20px;
}

.card-body h3 {
  font-size: 20px;
  color: #1A2332;
  margin: 0 0 10px 0;
  font-weight: 600;
}

.card-subtitle {
  font-size: 13px;
  color: #005BAF;
  margin: 0 0 12px 0;
  font-weight: 500;
}

.card-meta {
  font-size: 13px;
  color: #666;
  margin: 0 0 8px 0;
}

.card-desc {
  font-size: 14px;
  color: #666;
  margin: 15px 0 0 0;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-action {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e2e8f0;
}

.view-detail {
  color: #005BAF;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s;
}

.event-card:hover .view-detail {
  color: #FFB800;
}
</style>
